import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { CustomerType } from 'src/app/models/trofaco/customerDto';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
import { NgForm } from '@angular/forms';
import { DuplicateNameConfirmModalComponent } from '../../../customers/customer-details/duplicate-name-confirm-modal/duplicate-name-confirm-modal.component';
export class CreateCustomerModalComponent {
    constructor(customerService) {
        this.customerService = customerService;
        this.onAddedCustomer = new EventEmitter();
        this.customer = { certificates: [], customerType: CustomerType.B2C };
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.customersName = yield this.customerService.getCustomersName();
        });
    }
    show() {
        this.isInvalidDirectives.forEach(x => {
            if (x.controlName == 'name' || x.controlName == 'country')
                x.removeInvalidClass();
        });
        this.customerModal.show();
    }
    cancel() {
        this.customerModal.hide();
        this.markClean();
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isInvalidDirectives.forEach(x => {
                if (x.controlName == 'name' || x.controlName == 'country')
                    x.updateShowValid();
            });
            if (this.isInvalidDirectives.some(value => value.isInvalid))
                return;
            const newCustomerName = this.customer.name.trim().toLocaleLowerCase();
            let isDuplicateName = this.customersName.some((element) => {
                const customerName = element.trim().toLocaleLowerCase();
                return customerName === newCustomerName;
            });
            if (!isDuplicateName) {
                this.customersName.push(newCustomerName);
                this.execute();
                this.customerModal.hide();
            }
            else {
                this.customerModal.hide();
                let result = yield this.confirmDuplicateName.showAwait();
                if (result)
                    this.execute();
                else
                    this.markClean();
            }
        });
    }
    execute() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let id = yield this.customerService.create(this.customer);
            this.customer.id = id;
            this.onAddedCustomer.emit(Object.assign({}, this.customer));
            this.markClean();
        });
    }
    markClean() {
        this.customer = { certificates: [], customerType: CustomerType.B2C };
        this.form.control.markAsPristine();
        this.form.control.markAsUntouched();
    }
}
